import puppySellApi from "@/app/apis/main/puppy-sell/puppy-sell-api.js"

export default {
	/**
	 * @return {object} list of Puppy to be sell
	 * @params queryParams
	 * */
	async getPuppySellList(queryParams) {
		return puppySellApi.getPuppySellList(queryParams)
	},

	async getPuppySellPaymentList(queryParams) {
		return puppySellApi.getPuppySellPaymentList(queryParams)
	},

	async getPuppyPaymentDetails(puppySellId) {
		return puppySellApi.getPuppyPaymentDetails(puppySellId)
	},

	async getPuppyDetailsById(puppySellId) {
		return puppySellApi.getPuppyDetailsById(puppySellId)
	},

	async puppySellApprovedDeclined(details) {
		return puppySellApi.puppySellApprovedDeclined(details)
	},

	async getPendingPuppySellCount() {
		return puppySellApi.getPendingPuppySellCount()
	},

	async putPuppyPurchaseRefundApproval(details) {
		return puppySellApi.putPuppyPurchaseRefundApproval(details)
	},

	async updatePuppyDetailsStatus(puppySellId, details) {
		return puppySellApi.updatePuppyDetailsStatus(puppySellId, details)
	},

	// user roles is admin
	async updatePuppyDetailsStatusById(puppySellId, details) {
		return puppySellApi.updatePuppyDetailsStatusById(puppySellId, details)
	},

	async updatePuppyDetails(puppyDetails) {
		return puppySellApi.updatePuppyDetails(puppyDetails)
	},

	async putDeletePuppyToSell(puppySellId) {
		return puppySellApi.putDeletePuppyToSell(puppySellId)
	},
	async putPuppyPurchaseBalance(puppySellId, details) {
		return puppySellApi.putPuppyPurchaseBalance(puppySellId, details)
	},
}
